export const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
export const JIRA_BASE =
  process.env.REACT_APP_JIRA_URL || "https://ecosense-enviro.atlassian.net/browse";

export const jiraUrl = (ticketNo) => `${JIRA_BASE}/${ticketNo}`;
